export enum ProjectsOrderBy {
    ProjectName = 'PROJECT_NAME',
    LastChangeDate = 'LAST_CHANGE_DATE'
}
